import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import { MultiSelect } from 'react-multi-select-component';
import SlidingPanel from 'react-sliding-side-panel';
import noMessageIcon from '../../assets/Images/no-product-management.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import {
  ProductDefaultSortColumnOrder,
  ProductFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { IProductFilter } from '../../models/IProductFilter';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Pagination from '../../shared-components/Grid/Pagination';
import Header from '../../shared-components/header/header';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import {
  CloseSidePanelIcon,
  CopyIcon,
  DeleteIcon,
  EditIcon,
  ExportHolidayIcon,
  PlusIcon,
  RefreshIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import AddEditProductManagement from './components/add-edit-product-mgmt';
import FilterComponent from './components/filter';
import AddProductPopupHOC from './hoc/add-product-mgmt-popup-hoc';
import CopyProductPopupHOC from './hoc/copy-product-popup-hoc';
import ProductManagementDetails from './product-mgmt-details';
import './product-mgmt.css';
import { Search } from 'react-bootstrap-icons';
import CopyProduct from './components/copy-product';
import { ExclamationCircleFill } from 'react-bootstrap-icons';
import { Form as BsForm, Button } from 'react-bootstrap';

const ProductManagement = (props: any) => {
  const { productStore, preferencesStore, processTemplateStore, correctionControlStore } =
    useStore();
  const { GetPendingCountService } = correctionControlStore;

  const {
    GetProductListService,
    allProduct,
    productList,
    deleteProductState,
    DeleteProductService,
    resetDeleteProduct,
    resetProductDetail,
    addUpdateProductState,
    resetAddUpdateProductState,
    productState,
    getAllProductState,
    copyProductState,
    resetCopyProductState,
    GetProductByIdService,
    ValidateProductNameState,
    ValidateProductNameService,
    isProductNameValid,
    resetValidateProductNameState,
    allProductReactSelectOptions,
    GetAllProductService,
    productId,
    setProductId,
    getproductId,
    ExportProductReportService,
    exportProductReportState,
    resetExportProductReportState,
    base64String,
    updateCorrectionControlState,
    resetUpdateCorrectionControlState,
  } = productStore;
  const { resetProcessTemplateDetail } = processTemplateStore;
  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;
  let lang: string;
  const allProductListData = allProduct;
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    ProductDefaultSortColumnOrder
  );
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];
  const [filterObj, setFilterObj] = useState<IProductFilter>(
    ProductFilterInitialState
  );

  const [isCorrectionRequest, setIsCorrectionRequest] =
    useState<boolean>(false);
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const [showOptions, setShowOptions] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isProductIdApplied, setIsProductIdApplied] = useState(false);

  const productColumnOptions = [
    { label: 'product_id', value: 'ProductName', payloadName: '品番ID' },
    { label: 'katashiki', value: 'Katashiki', payloadName: '形式' },
    { label: 'customer', value: 'Customer', payloadName: '得意先' },
    { label: 'tray_size', value: 'TraySize', payloadName: 'トレイのサイズ' },
    { label: 'key_info_1', value: 'KeyInfo1', payloadName: 'キー情報 1' },
    { label: 'key_info_2', value: 'KeyInfo2', payloadName: 'キー情報 2' },
    { label: 'key_info_3', value: 'KeyInfo3', payloadName: 'キー情報 3' },
    { label: 'comment', value: 'Remarks', payloadName: 'コメント' },
    { label: 'created_by', value: 'CreatedBy', payloadName: '作成者' },
    { label: 'created_date', value: 'CreatedDate', payloadName: '作成日' },
    { label: 'updated_by', value: 'UpdatedBy', payloadName: '更新者' },
    { label: 'updated_date', value: 'UpdatedDate', payloadName: '更新日' },
    { label: 'process_name', value: 'ProcessName', payloadName: '工程名' },
    { label: 'short_name', value: 'ShortName', payloadName: 'ショート名' },
    { label: 'category', value: 'ProcessType', payloadName: 'カテゴリ' },
    { label: 'default_due_date', value: 'ProcessDueDate', payloadName: 'デフォルトの期日' },
    { label: 'standard_time', value: 'StandardTime', payloadName: '想定時間' },
    { label: 'view_type', value: 'ViewType', payloadName: '表示タイプ' },
    { label: 'common', value: 'Heading', payloadName: '共通' },
    { label: 'items', value: 'Items', payloadName: 'Items' },
  ];

  const [selectedColumns, setSelectedColumns] = useState<any[]>(
    productColumnOptions.map((opt) => ({
      ...opt,
      label: formatMessage(opt.label),
    }))
  );

  useEffect(() => {
    setSelectedColumns((prev) =>
      prev.map((item) => {
        const found = productColumnOptions.find(
          (opt) => opt.value === item.value
        );
        return {
          ...item,
          label: found ? formatMessage(found.label) : item.label,
        };
      })
    );
  }, [language]);

  const handleColumnSelectionChange = (newSelected: any[]) => {
    const productIdOpt = productColumnOptions.find(
      (opt) => opt.value === 'ProductName'
    );
    const hasProductId = newSelected.some(
      (col: any) => col.value === 'ProductName'
    );

    if (!hasProductId && productIdOpt) {
      const formattedOpt = {
        ...productIdOpt,
        label: formatMessage(productIdOpt.label),
      };
      setSelectedColumns([formattedOpt, ...newSelected]);
    } else {
      setSelectedColumns(newSelected);
    }
  };

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    closePanelHandler();
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getProductListServiceHandler = (
    currentFilter = filterObj,
    isFilter = false,
    pageOverride?: number
  ) => {
    const pageNo = pageOverride ?? (isFilter ? 1 : pageInfo.currentPage);
    const pageSize = pageLimitInfo.pageLimit;
    const tenantId = Number(getTenantIdFromLocalStorage());

    const formatIsoDate = (dateVal: any) => {
      if (!dateVal) return null;
      const d = dateVal instanceof Date ? dateVal : new Date(dateVal);
      return !isNaN(d.getTime()) ? d.toISOString() : null;
    };

    const payload = {
      pagingDetail: {
        CurrentPage: pageNo,
        PageSize: pageSize,
        TotalPages: pageInfo.totalPages || 0,
        TotalRecords: 0,
      },
      ProductFilters: {
        Katashiki: currentFilter?.Katashiki || '',
        ProductId: currentFilter?.ProductId || '',
        CreatedBy: currentFilter?.CreatedBy || '',
        UpdatedBy: currentFilter?.UpdatedBy || '',
        CreatedOn: formatIsoDate(currentFilter?.CreatedDate),
        UpdatedOn: formatIsoDate(currentFilter?.UpdatedDate),
        IsCorrectionRequest: isCorrectionRequest,
        Column:
          currentFilter?.Column || columSortOrder.dataField || 'ProductId',
        Order: currentFilter?.Order || columSortOrder.order || 'asc',
      },
      TenantId: tenantId,
    };

    GetProductListService(payload);
  };

  useEffect(() => {
    if (isProductNameValid) {
      toast.error(formatMessage('AlreadyExists'));
    }
  }, [isProductNameValid]);

  useEffect(() => {
    getProductListServiceHandler(filterObj, true);
  }, [filterObj, isCorrectionRequest]);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: productList?.PagingDetails?.CurrentPage,
      totalPages: productList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [productList]);

  useEffect(() => {
    if (!isProductIdApplied || !getproductId) return;

    const matchingProduct =
      allProductListData.find(
        (product: any) => product.ProductName === getproductId
      ) ||
      (allProductListData.length === 1 ? allProductListData[0] : undefined);

    if (matchingProduct) {
      setSelectedRow((previousRow: any) =>
        previousRow?.Id === matchingProduct.Id ? previousRow : matchingProduct
      );
      // setOpenPanel(true);
    } else {
      setSelectedRow({});
      setOpenPanel(false);
      resetProductDetail();
    }
  }, [productList, isProductIdApplied, getproductId]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getProductListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getProductListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (language !== lang) {
      getProductListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (copyProductState.success) {
      const newProductId = productStore.newCopiedProductId;
      resetCopyProductState();
      getProductListServiceHandler();
      if (newProductId && newProductId > 0) {
        openAddProductHandler({ Id: newProductId }, undefined, true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [copyProductState.success]);

  useEffect(() => {
    if (addUpdateProductState.success) {
      resetAddUpdateProductState();
      getProductListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateProductState.success]);

  useEffect(() => {
    if (deleteProductState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteProduct();
      getProductListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteProductState.success]);

  useEffect(() => {
    if (updateCorrectionControlState.success) {
      resetUpdateCorrectionControlState();
      getProductListServiceHandler();
      const tenantId = getTenantIdFromLocalStorage();
      if (tenantId && Number(tenantId) > 0) {
        GetPendingCountService(Number(tenantId));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCorrectionControlState.success]);

  useEffect(() => {
    setProductId('');
    // GetAllProductService(Number(getTenantIdFromLocalStorage()));
    // return () => {
    //   setProductId('');
    // };
  }, []);

  const handleExport = (base64Data: string) => {
    // Decode the base64 string
    const binaryData = atob(base64Data);
    const binaryArray = new Uint8Array(binaryData.length);

    // Fill the binary array with the decoded binary data
    for (let i = 0; i < binaryData.length; i++) {
      binaryArray[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob from the binary data with the MIME type for Excel
    const blob = new Blob([binaryArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // Create a URL for the Blob and set up the download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const now = new Date();
    const japanDate = new Date(
      now.toLocaleString('en-US', { timeZone: 'Asia/Tokyo' })
    );

    const jpString =
      japanDate.getFullYear().toString() +
      String(japanDate.getMonth() + 1).padStart(2, '0') +
      String(japanDate.getDate()).padStart(2, '0') +
      String(japanDate.getHours()).padStart(2, '0') +
      String(japanDate.getMinutes()).padStart(2, '0') +
      String(japanDate.getSeconds()).padStart(2, '0');
    link.download = `ProductReportFile-${jpString}.csv`;
    // Trigger the download by simulating a click on the link
    document.body.appendChild(link);
    link.click();

    // Clean up and remove the link after download
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    closePanelHandler();
    // resetFactoryScheduleDetail();
  };

  useEffect(() => {
    if (exportProductReportState.success) {
      handleExport(base64String.fileString);
      resetExportProductReportState();
    }
  }, [exportProductReportState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    const target = e?.target as HTMLElement;
    if (
      target?.closest('.last-column') ||
      target?.closest('button') ||
      target?.closest('a') ||
      target?.closest('svg')
    ) {
      return;
    }
    setSelectedRow(row);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
    productStore.resetProductDetailData();
  };

  const applyProductIdFilter = () => {
    const productIdValue = getproductId.trim();

    if (!productIdValue) {
      clearProductIdFilter();
      return;
    }

    setSelectedRow({});
    setOpenPanel(false);
    resetProductDetail();
    setFilterObj((previousFilter) => ({
      ...previousFilter,
      ProductId: productIdValue,
    }));
    setIsProductIdApplied(true);
  };

  const clearProductIdFilter = () => {
    setIsProductIdApplied(false);
    setFilterObj((previousFilter) => ({
      ...previousFilter,
      ProductId: '',
    }));
    setProductId('');
    setSelectedRow({});
    setOpenPanel(false);
    resetProductDetail();
  };

  const refreshClickHandler = () => {
    getProductListServiceHandler();
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteProductService(Number(getTenantIdFromLocalStorage()), selectedId);
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetProductDetail();
    props.deletePopupToggleHandler();
  };

  const copyClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetProductDetail();
    // GetProductByIdService(Number(getTenantIdFromLocalStorage()), row.Id, true);
    // openAddProductHandler({ Id: -1 }, event, false);
    props.copyToggleHandler();
  };

  const openAddProductHandler = (
    row: { Id: number },
    event?: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    isReset: boolean = true
  ) => {
    localStorage.setItem('images', JSON.stringify([]));
    if (event) event.stopPropagation();
    closePanelHandler();
    if (isReset) resetProductDetail();
    // resetProductDetail();
    setSelectedId(row.Id);
    props.addToggleHandler(true);
    resetProcessTemplateDetail();
  };

  const createQueryString = (filter: IProductFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: IProductFilter) => {
    const filters = {
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    };
    setFilterObj({ ...filters });
    props.filterPopupToggleHandler();
    closePanelHandler();
    setIsFilterCleared(false);
  };

  const filterParams = (obj: IProductFilter, isFilterCleared: boolean) => {
    const filters = {
      ...obj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    };

    if (isFilterCleared) {
      setFilterObj({ ...filters });
      closePanelHandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...filters });
    }
    props.filterPopupToggleHandler();
  };

  const exportFileHandler = () => {
    const tenantId = Number(getTenantIdFromLocalStorage());

    const ignoreColumns = productColumnOptions
      .filter((opt) => !selectedColumns.some((sel) => sel.value === opt.value))
      .map((opt) => opt.payloadName);

    const formatIsoDate = (dateVal: any) => {
      if (!dateVal) return null;
      const d = dateVal instanceof Date ? dateVal : new Date(dateVal);
      return !isNaN(d.getTime()) ? d.toISOString() : null;
    };

    const payload = {
      TenantId: tenantId,
      ProductFltr: {
        Katashiki: filterObj.Katashiki || '',
        ProductId: filterObj.ProductId || '',
        CreatedBy: filterObj.CreatedBy || '',
        UpdatedBy: filterObj.UpdatedBy || '',
        CreatedOn: formatIsoDate(filterObj.CreatedDate),
        UpdatedOn: formatIsoDate(filterObj.UpdatedDate),
        IsCorrectionRequest: isCorrectionRequest,
        Column: filterObj.Column || columSortOrder.dataField || 'ProductId',
        Order: filterObj.Order || columSortOrder.order || 'asc',
      },
      IgnoreColumns: ignoreColumns,
    };

    ExportProductReportService(payload);
  };

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isEdit',
        handler: openAddProductHandler,
        icon: <EditIcon />,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.ProductManagement,
          'Edit'
        ),
        title: 'edit',
        varient: 'primary',
        action: 'edit',
      },
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: <DeleteIcon />,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.ProductManagement,
          'Delete'
        ),
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },
      {
        dataField: 'isCopy',
        handler: copyClickHandler,
        icon: <CopyIcon />,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.ProductManagement,
          'Copy'
        ),
        title: 'copy',
        varient: 'success',
        action: 'copy',
      },
    ],
    ModuleType.ProductManagement
  );

  const isColumnVisible = (dataField: string) => {
    if (!selectedColumns || selectedColumns.length === 0) return true;
    return selectedColumns.some((col: any) => col.value === dataField);
  };

  const columns: any = [
    {
      dataField: 'ProductName',
      text: formatMessage('product_id'),
      classes: 'show-Elipses',
      hidden: false,
      formatter: (cell: any, row: any) => {
        const hasCorrection = Boolean(
          row?.CorrectionRequest === true ||
          (row?.CorrectionRequest && typeof row?.CorrectionRequest === 'object' && !row?.CorrectionRequest?.IsCompleted) ||
          (row?.HasCorrectionRequest && !row?.IsCorrectionCompleted)
        );
        return (
          <span className="d-inline-flex align-items-center gap-1">
            <span>{cell}</span>
            {hasCorrection && (
              <ExclamationCircleFill
                className="text-danger"
                title={formatMessage('correction_request')}
              />
            )}
          </span>
        );
      },
    },

    {
      dataField: 'Katashiki',
      text: formatMessage('katashiki'),
      classes: 'show-Elipses',
      hidden: false,
    },
    {
      dataField: 'Customer',
      text: formatMessage('customer'),
      classes: 'show-Elipses',
      hidden: false,
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'TraySize',
      text: formatMessage('tray_size'),
      classes: 'show-Elipses',
      hidden: false,
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'Remarks',
      text: formatMessage('comment'),
      classes: 'show-Elipses',
      hidden: false,
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: '',
      formatter: CustomActionFormatter(actionIcons),
      text: formatMessage('actions'),
      classes: 'last-column',
      hidden: actionIcons.length > 0 ? false : true,
    },
  ];

  const filteredColumns = columns.filter((col: any) => !col.hidden);

  return (
    <>
      {props.showAddProductPopup && (
        <AddEditProductManagement
          id={selectedId}
          modalClosed={props.addToggleHandler}
        />
      )}

      {props.showCopyProductPopup && (
        <CopyProduct
          id={selectedId}
          modalClosed={props.copyToggleHandler}
        />
      )}

      {props.showDeletePopup && (
        <DeletePopup
          title="delete_product"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_product_confirm"
          isLoading={deleteProductState.inProgress}
        />
      )}

      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row g-1 align-items-center">
          <Header
            className="col-xxl-4 col-xl-3 col-lg-3 col-md-12 col-sm-12"
            label="product_title"
          />
          <div className="col-xxl-8 col-xl-9 col-lg-9 col-md-12 col-sm-12">
            <ul className="add-list ps-0">
              <li
                title={`${formatMessage('pending_correction_request')}`}
                className="d-flex align-items-center g-2 ms-4 ps-1 show-group"
              >
                <BsForm.Check
                  type="switch"
                  id="custom-switch"
                  className="btn"
                  checked={isCorrectionRequest}
                  onChange={(e) => {
                    closePanelHandler();
                    setIsCorrectionRequest(e.target.checked);
                  }}
                />
                <p className="auto-refresh text-white">
                  {formatMessage('pending')} <ExclamationCircleFill />
                </p>
              </li>
              <li className="d-flex">
                <div className="mx-2 search-id-prod">
                  <div
                    className=""
                    style={{
                      position: 'relative',
                    }}
                  >
                    <input
                      className="form-control"
                      type="text"
                      value={getproductId}
                      placeholder={formatMessage('product_id')}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ''); // remove non-numeric characters
                        setProductId(value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          applyProductIdFilter();
                        }
                      }}
                    />{' '}
                    <button
                      type="button"
                      onClick={() => {
                        applyProductIdFilter();
                      }}
                      className={`btn btn-sm ${isProductIdApplied ? 'remove-btn-product-search' : 'remove-btn-product-search-fix '}`}
                    >
                      <Search />
                    </button>
                    {isProductIdApplied && (
                      <button
                        type="button"
                        onClick={() => {
                          clearProductIdFilter();
                        }}
                        className="btn btn-danger btn-sm remove-btn-product"
                      >
                        &times;
                      </button>
                    )}
                  </div>
                </div>
                {/* <div className="">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      productId &&
                        setFilterObj(() => ({
                          ...filterObj,
                          ProductId: productId,
                        }));
                      setIsFilterApplied(true);
                    }}
                  >
                    {formatMessage('search')}
                  </button>
                </div> */}
              </li>
              <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isFilterCleared={isFilterCleared}
                  isLoading={false}
                  isDisable={false}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                  setSearchTerm={setSearchTerm}
                />
              </li>
              <li>
                <MultiSelect
                  options={productColumnOptions.map((field) => ({
                    ...field,
                    label: formatMessage(field.label),
                  }))}
                  value={selectedColumns}
                  onChange={handleColumnSelectionChange}
                  labelledBy="Select"
                  className={`multiselect-react product-select ${allProductListData.length === 0 ? 'div-disabled' : ''}`}
                  valueRenderer={() => formatMessage('report_field_selection')}
                  overrideStrings={{
                    selectAll: formatMessage('select_all_options'),
                    selectAllFiltered: formatMessage('select_all_filtered'),
                    search: formatMessage('search'),
                  }}
                />
              </li>
              <li title={formatMessage('factory_schedule_export')}>
                <a
                  data-toggle="modal"
                  className={`btn btn-light`}
                  onClick={() => exportFileHandler()}
                >
                  <ExportHolidayIcon />
                </a>
              </li>
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.ProductManagement,
                'Add'
              ) && (
                <li title={formatMessage('add_product')}>
                  <a
                    className="btn btn-secondary"
                    data-toggle="modal"
                    data-testid="modalbtn"
                    data-target="#addUser"
                    onClick={(event: any) =>
                      openAddProductHandler({ Id: -1 }, event)
                    }
                  >
                    <span className="me-1">
                      <PlusIcon />
                    </span>
                    <span className="d-none d-xxl-inline"><FormattedMessage id="add_product" /></span>
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>

      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          <FormLoader loading={getAllProductState.inProgress} />
          {allProductListData && allProductListData.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive tray-management-table"
                    data-testid="table"
                  >
                    {allProductListData && (
                      <Grid
                        data={allProductListData}
                        columns={filteredColumns}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        hover={true}
                      />
                    )}
                  </div>
                </div>
              </div>

              {allProductListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={productList.PagingDetails.TotalRecords}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div className="col-lg-8 mt-5 p-3">
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_product" />
                  </h3>
                  <h4 className="mb-3">
                    {formatMessage('no_product_message')}
                  </h4>
                  {isOperationPermittedRoleBase(
                    ModuleType.ProductManagement,
                    'Add'
                  ) && (
                    <>
                      <a
                        className="btn btn-primary"
                        onClick={(event: any) =>
                          openAddProductHandler({ Id: -1 }, event)
                        }
                      >
                        <span className="me-1">
                          <PlusIcon />
                        </span>
                        <FormattedMessage id="add_product" />
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow.ProductName}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            <ProductManagementDetails selectedRowId={selectedRow.Id} />
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default CopyProductPopupHOC(
  FilterPopupHOC(
    AddProductPopupHOC(DeletePopupHOC(observer(ProductManagement)))
  )
);
